// client/src/pages/Register.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import RegisterForm from '../components/RegisterForm';
import '../styles/Login.css'; // Reusing the same CSS since styles are identical

function Register() {
  return (
    <>
      <Helmet>
        <title>Konto erstellen | DynaStoxx</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>Konto erstellen</h1>
            <p className="text-muted">Registriere dich kostenlos und starte mit der Analyse deiner Investments.</p>
          </div>
          <RegisterForm />
        </div>
      </div>
    </>
  );
}

export default Register;